module.exports = __webpack_public_path__ + "img/total_debits.97439deb.png";